import { put, call, delay } from "redux-saga/effects";
import UserActions from "../store/user/Actions";
import { userService } from "../services/UserService";
import { ERROR_HAPPENED } from "../constants/index";
/**
 * A saga can contain multiple functions.
 *
 * This saga used for user login.
 */
// syed: this file has all methods defined which are invoked via user action(defined in matchDispatchToProps/UI and Action.js)

export function* classLinkLogin(data) {
  const { loginId, successFn, failureFn } = data;
  const userData = yield call(userService.classLinkLogin, loginId);
  if (userData === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (userData && userData.LoginID) {
      yield call(successFn, userData);
    } else {
      yield call(failureFn, userData);
    }
  }
}

export function* userLogin(data) {
  const { username, password, domain, successFn, failureFn } = data;
  const userResponse = yield call(
    userService.userLogin,
    username,
    password,
    domain
  );
  if (userResponse === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    yield call(successFn, userResponse);
  }
}

export function* refreshToken(data) {
  const { tokenData, successFn, failureFn } = data;
  const userResponse = yield call(userService.refreshToken, tokenData);
  if (userResponse === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    yield call(successFn, userResponse);
  }
}

export function* getCourseListForStudent(data) {
  const { loginId, token, successFn, failureFn } = data;
  const courseList = yield call(
    userService.getCourseListForStudent,
    loginId,
    token
  );
  if (courseList === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (courseList) {
      yield call(successFn, courseList);
    } else {
      yield call(failureFn, []);
      console.log("getCourseListForStudent failure");
    }
  }
}

export function* getChapterListForStudent(data) {
  const { subjectId, loginId, token, successFn, failureFn } = data;
  const chapterList = yield call(
    userService.getChapterListForStudent,
    subjectId,
    loginId,
    token
  );
  if (chapterList === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (chapterList) {
      yield call(successFn, chapterList);
    } else {
      yield call(failureFn, []);
      console.log("getCourseListForStudent failure");
    }
  }
}

export function* getLessonFoldersForStudent(data) {
  console.log("data", data);
  const {
    studentId,
    DomainID,
    SubjectID,
    ChapterID,
    token,
    successFn,
    failureFn,
  } = data;
  const lessonFolders = yield call(
    userService.getLessonFoldersForStudent,
    studentId,
    DomainID,
    SubjectID,
    ChapterID,
    token
  );
  if (lessonFolders === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (lessonFolders) {
      yield call(successFn, lessonFolders);
    } else {
      yield call(failureFn, []);
      console.log("getCourseListForStudent failure");
    }
  }
}

export function* getAssignmentDataForStudent(data) {
  const { studentId, courseId, lessonId, ChapterID, token, successFn } = data;
  const pendingAssignmentData = yield call(
    userService.getLessonUnitsForAStudent,
    studentId,
    courseId,
    lessonId,
    ChapterID,
    token
  );
  console.log("pendingAssignmentData", pendingAssignmentData);
  // const pendingAssignmentData = yield call(
  //   userService.getPendingAssignmentDataForStudent,
  //   studentId,
  //   courseId,
  //   lessonId,
  //   ChapterID,
  //   token
  // );
  // const completedAssignmentData = yield call(
  //   userService.getCompletedLessonUnitDetailsForStudent,
  //   studentId,
  //   lessonId,
  //   ChapterID,
  //   token
  // );
  // const assignmentData = {
  //   pending: pendingAssignmentData,
  //   completed: completedAssignmentData,
  // };
  if (pendingAssignmentData === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (pendingAssignmentData) {
      yield put(
        UserActions.getAssignmentDataForStudentSuccess(pendingAssignmentData)
        // UserActions.getAssignmentDataForStudentSuccess(assignmentData.Data)
      );
      yield call(successFn, pendingAssignmentData);
    } else {
      console.log("getAssignmentDataForStudent failure");
    }
  }
}

export function* getAssignmentDataSummaryForStudent(data) {
  const { studentId, lessonUnitDistId, successFn } = data;
  const assignmentDataSummary = yield call(
    userService.getAssignmentDataSummaryForStudent,
    studentId,
    lessonUnitDistId
  );
  if (assignmentDataSummary === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (assignmentDataSummary) {
      yield put(
        UserActions.saveAssignmentSummaryForStudentSuccess(
          assignmentDataSummary
        )
      );
      yield call(successFn, assignmentDataSummary);
    } else {
      console.log("getAssignmentSummaryForStudent failure");
    }
  }
}

export function* getLessonUnitDetailsForStudent(data) {
  const { studentId, lessonUnitDistId, token, successFn } = data;
  const lessonUnitDetails = yield call(
    userService.getLessonUnitDetailsForStudent,
    studentId,
    lessonUnitDistId,
    token
  );

  if (lessonUnitDetails === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (lessonUnitDetails) {
      yield put(UserActions.setCurrentLessonUnitDistId(lessonUnitDistId));
      yield put(UserActions.saveLessonUnitDetailsForStudent(lessonUnitDetails));
      yield call(successFn, lessonUnitDetails);
    } else {
      console.log("getLessonUnitDetailsForStudent failure");
    }
  }
}

export function* getActivityForStudent(data) {
  const { StudentID, ContentID, token, successFn } = data;
  const response = yield call(
    userService.getActivityForStudent,
    StudentID,
    ContentID,
    token
  );
  if (response === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (response) {
      yield put(
        UserActions.setCurrentActivityDetails(
          response.Data.GetBackpackActivityForStudentResult
        )
      );
      yield put(
        UserActions.setWorkJson(
          response.Data.GetBackpackActivityForStudentResult.WorkJson
        )
      );
      yield call(successFn, response);
    } else {
      console.log("saveActivityForStudent failure");
    }
  }
}

//get contained activity for marker
export function* getContainedActivityForStudent(data) {
  const { StudentID, ContentID, token, successFn } = data;
  const response = yield call(
    userService.getContainedActivityForStudent,
    StudentID,
    ContentID,
    token
  );
  if (response === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (response) {
      yield put(
        UserActions.setCurrentContainedActivityDetails(
          response.Data.GetBackpackActivityForStudentResult
        )
      );
      yield put(
        UserActions.setContainedWorkJson(
          response.Data.GetBackpackActivityForStudentResult.WorkJson
        )
      );
      yield call(successFn, response);
    } else {
      console.log("saveActivityForStudent failure");
    }
  }
}

export function* saveActivityForStudent(data) {
  const { token, activity, successFn } = data;
  const response = yield call(
    userService.saveActivityForStudent,
    token,
    activity
  );
  if (response === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (response) {
      yield call(successFn, response);
    } else {
      console.log("saveActivityForStudent failure");
    }
  }
}
export function* unlockOfflineLessonUnit(data) {
  const { unlocklesson, successFn } = data;
  const response = yield call(
    userService.unlockOfflineLessonUnit,
    unlocklesson
  );
  if (response === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (response) {
      yield call(successFn, response);
    } else {
      console.log("UnlockOfflineLessonUnit failure");
    }
  }
}
export function* unlockOfflineCourse(data) {
  const { unlockcourse, successFn } = data;
  const response = yield call(userService.unlockOfflineCourse, unlockcourse);
  if (response === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (response) {
      yield call(successFn, response);
    } else {
      console.log("unlockOfflineCourse failure");
    }
  }
}

export function* setExerciseList(data) {
  const { exerciseList, successFn } = data;
  yield put(UserActions.saveExerciseListInState(exerciseList));
  yield call(successFn);
}

export function* setPreviousExerciseList(data) {
  const { exerciseList, successFn } = data;
  yield put(UserActions.savePreviousExerciseInState(exerciseList));
  yield call(successFn);
}

export function* getUpcomingAssignmentForStudent(data) {
  const { studentId, assignmentDate, token, successFn } = data;
  const upcomingAssignmentList = yield call(
    userService.getUpcomingAssignmentForStudent,
    studentId,
    assignmentDate,
    token
  );
  if (upcomingAssignmentList === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (upcomingAssignmentList) {
      yield call(successFn, upcomingAssignmentList);
    } else {
      console.log("getUpcomingAssignmentListForStudent failure");
    }
  }
}

export function* changeLoggedOutStatus(data) {
  const { successFn } = data;
  yield put(UserActions.changeLoggedOutStatusInState());
  yield call(successFn);
}

export function* forgotPasswordStudent(data) {
  const { LoginName, DomainName, successFn } = data;
  const forgotPasswordStudentResponse = yield call(
    userService.forgotPasswordStudent,
    LoginName,
    DomainName
  );
  if (forgotPasswordStudentResponse === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (forgotPasswordStudentResponse) {
      console.log(forgotPasswordStudentResponse);
      yield call(successFn, forgotPasswordStudentResponse);
    } else {
      console.log("forgotPasswordStudent failure");
    }
  }
}

export function* getLessonFolderBySubject(data) {
  const { DomainID, StudentID, SubjectID, successFn } = data;
  const getLessonFolderBySubjectResponse = yield call(
    userService.getLessonFolderBySubject,
    DomainID,
    StudentID,
    SubjectID
  );
  if (getLessonFolderBySubjectResponse === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (getLessonFolderBySubjectResponse) {
      console.log(getLessonFolderBySubjectResponse);
      yield call(successFn);
    } else {
      console.log("getLessonFolderBySubjectResponse failure");
    }
  }
}

export function* getLessonUnitsByFolder(data) {
  const { StudentID, LessonID, successFn } = data;
  const getLessonUnitsByFolderResponse = yield call(
    userService.getLessonUnitsByFolder,
    StudentID,
    LessonID
  );
  if (getLessonUnitsByFolderResponse === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (getLessonUnitsByFolderResponse) {
      console.log(getLessonUnitsByFolderResponse);
      yield call(successFn);
    } else {
      console.log("getLessonUnitsByFolderResponse failure");
    }
  }
}

export function* getCourseSummaryAnalyticsReport(data) {
  const { DomainID, CourseID, StudentID, successFn } = data;
  const CourseAnalytics = yield call(
    userService.getCourseSummaryAnalyticsReport,
    DomainID,
    CourseID,
    StudentID
  );
  console.log(CourseAnalytics, "CourseAnalytics");
  if (CourseAnalytics === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (CourseAnalytics) {
      yield put(
        UserActions.getCourseSummaryAnalyticsReportSuccess(CourseAnalytics)
      );
      yield call(successFn, CourseAnalytics);
    } else {
      console.log("getCourseSummaryAnalyticsReport failure");
    }
  }
}

export function* getLessonPodSummaryAnalyticsReport(data) {
  const { LessonUnitDistID, StudentID, successFn } = data;
  const StudentLessonpodAnalytics = yield call(
    userService.getLessonPodSummaryAnalyticsReport,
    LessonUnitDistID,
    StudentID
  );
  console.log(StudentLessonpodAnalytics, "StudentLessonpodAnalytics");
  if (StudentLessonpodAnalytics === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (StudentLessonpodAnalytics) {
      yield put(
        UserActions.getLessonPodSummaryAnalyticsReportSuccess(
          StudentLessonpodAnalytics
        )
      );
      yield call(successFn, StudentLessonpodAnalytics);
    } else {
      console.log("getLessonPodSummaryAnalyticsReport failure");
    }
  }
}

export function* getLessonPodActivityAnalyticsReport(data) {
  const { ContentID, StudentID, successFn } = data;
  const StudentActivityAnalytics = yield call(
    userService.getLessonPodActivityAnalyticsReport,
    ContentID,
    StudentID
  );
  if (StudentActivityAnalytics === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (StudentActivityAnalytics) {
      yield put(
        UserActions.getLessonPodActivityAnalyticsReportSuccess(
          StudentActivityAnalytics
        )
      );
      yield call(successFn, StudentActivityAnalytics);
    } else {
      console.log("getLessonPodActivityAnalyticsReport failure");
    }
  }
}

export function* chatChallengeMe(data) {
  const {
    serviceTypeName,
    topic,
    keyword,
    question_type,
    num_of_options,
    content,
    successFn,
    failureFn,
  } = data;
  const ChallengeData = yield call(
    userService.chatChallengeMe,
    serviceTypeName,
    topic,
    keyword,
    question_type,
    num_of_options,
    content
  );
  if (ChallengeData === "TIMEOUT_ERROR") {
    alert(ERROR_HAPPENED);
  } else {
    if (ChallengeData) {
      yield call(successFn, ChallengeData);
    } else {
      yield call(failureFn, ChallengeData);
      console.log("ChallengeData failure");
    }
  }
}
